<template>
  <hr class="divider" />
</template>

<script lang="ts">
export default {
  name: "DividerComponent",
}
</script>

<style scoped lang="scss">
.divider {
  border-top: 2px solid rgba(29, 29, 29, 0.15);
}
</style>
